import get from "lodash/get";
import trim from "lodash/trim";
import isEmpty from "lodash/isEmpty";
import noop from "lodash/noop";

import feathersApp from "../feathers";

import config from "@config";
// import { loading } from "@actions";
// import * as analytics from "@analytics";
import { avoidLandingPage } from "@selectors/location";

const landingPath = `${config.basePath}/`; // `${config.basePath}/reglas`;
const CLIENT_ID = config.clientId;

export const getTokenFromCookie = (key, win = window) => {
  let kvList = get(win, "document.cookie", "").split(";");
  let foundPair = kvList.filter((pair) => trim(pair.split("=")[0]) === key);
  return isEmpty(foundPair) ? noop() : trim(foundPair[0].split(`${key}=`)[1]);
};

export const isTokenExpired = (win = window) => {
  let expiration = Number(
    win.localStorage.getItem(config.expireTokenLocalStoreName)
  );
  return !(expiration && new Date(expiration * 1000) > new Date());
};

export const logout =
  (win = window) =>
  async (dispatch, getState) => {
    await feathersApp.logout();
    dispatch({ type: "AUTH_CLEAR" });

    if (avoidLandingPage(getState())) {
      return;
    }

    win.location.replace(landingPath); // TODO: double check this redirect
  };
/*
export const loadAuthUser = () => async (dispatch, getState) => {
  dispatch(loading(true));

  try {
    const { user } = await feathersApp.get("authentication");
    dispatch({ type: "AUTH_SET_USER", payload: user });
    dispatch(loading(false));

    analytics.set({ userId: user._id });

    // TODO: Welcome Modal is Disabled
    // if (get(data, 'sawWelcome', 0) < get(config, 'welcomeTimes', 1)) {
    //   dispatch({ type: 'WELCOME_VISIBLE', payload: true });
    // }

    return user;
  } catch (err) {
    console.error(err);
    dispatch(logout());
    dispatch(loading(false));
  }
};
/*
export const checkAuth =
  (win = window) =>
  async (dispatch, getState) => {
    if (!feathersApp.authenticate.authenticated) {
      try {
        await feathersApp.reAuthenticate();
      } catch (e) {
        console.log("Couldn't authenticate");
        console.log(e);

        return; // win.location.replace(landingPath); // go to landing ?
      }
    }

    const token = await feathersApp.authentication.getAccessToken();
    dispatch({ type: "AUTH_SET_TOKEN", payload: token });
    
    //if (!win.localStorage.getItem(config.landingZarLocalStoreName)) {
    //  return win.location.replace(landingPath);
    //}

    return dispatch(loadAuthUser());
  };
*/
export const loginWithGoogle =
  (win = window) =>
  (dispatch, getState) => {
    const returnTo = win.location.origin + win.location.pathname.replace(/\/$/, '');
    win.location.replace(`${config.apiURL}/oauth/google?redirect=${encodeURIComponent(returnTo)}`);
  };

export const loginWithFacebook =
  (win = window) =>
  (dispatch, getState) => {
    const returnTo = win.location.origin + win.location.pathname.replace(/\/$/, '');
    win.location.replace(`${config.apiURL}/oauth/facebook?redirect=${encodeURIComponent(returnTo)}`);
  };

// Acción simplificada para verificar si hay sesión con auth-provider
// (opcional, para chequeos adicionales si es necesario)
export const checkAuthProvider = () => async (dispatch) => {
  try {
    const response = await fetch(`${config.authProviderURL}/user`, {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const userData = await response.json();
      return userData;
    }
    return null;
  } catch (error) {
    console.error('Error verificando auth-provider:', error);
    return null;
  }
};

export const loginWithAuthProvider = (win = window) => () => {
  const returnTo =
    config.inviteHost || `${config.host}${win.location.pathname.replace(/\/$/, '')}`;
  const devAutoLoginEnabled = config.devAutoLoginEnabled === true;
  const devAutoLoginEmail = String(config.devAutoLoginEmail || '').trim();
  if (devAutoLoginEnabled && devAutoLoginEmail) {
    const devLoginUrl = `${config.apiURL}/auth-provider/dev-login?email=${encodeURIComponent(
      devAutoLoginEmail
    )}&returnTo=${encodeURIComponent(returnTo)}`;
    win.location.href = devLoginUrl;
    return;
  }
  const callbackUrl = `${config.apiURL}/auth-provider/callback?returnTo=${encodeURIComponent(returnTo)}`;
  const loginUrl = `${config.authProviderURL}/ingresar?client=${CLIENT_ID}&redirect=${encodeURIComponent(callbackUrl)}`;
  win.location.href = loginUrl;
};

export const registerWithAuthProvider = (win = window) => () => {
  const returnTo = win.location.origin + win.location.pathname.replace(/\/$/, '');
  const callbackUrl = `${config.apiURL}/auth-provider/callback?returnTo=${encodeURIComponent(returnTo)}`;
  const registerUrl = `${config.authProviderURL}/registrar?client=${CLIENT_ID}&redirect=${encodeURIComponent(callbackUrl)}`;
  win.location.href = registerUrl;
};

export const logoutAuthProvider = (win = window) => async (dispatch) => {
  // Limpiar autenticación de prode-api
  try {
    await feathersApp.authentication.logout();
  } catch (error) {
    console.error('Error al hacer logout de prode-api:', error);
  }
  
  dispatch({ type: 'AUTH_CLEAR' });
  
  // Redirigir al logout de auth-provider
  const redirectUrl = win.location.origin + config.basePath;
  const logoutUrl = `${config.authProviderURL}/logout-user?redirect=${encodeURIComponent(redirectUrl)}`;
  win.location.href = logoutUrl;
};
